import React from "react";
import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function TranslationDropdown() {
  const { i18n } = useTranslation("common");

  return (
    <Box sx={{ mr: 2, justifyContent: "flex-end", display: "flex" }}>
      <FormControl variant="standard">
        <Select
          value={i18n.language}
          disableUnderline
          onChange={(e) => {
            i18n.changeLanguage(e.target.value);
          }}
          displayEmpty
          sx={{
            height: 40,
            fontWeight: 600,
          }}
        >
          <MenuItem value={"en"}>EN</MenuItem>
          <MenuItem value={"id"}>ID</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
